import OperationalReportPage from './OperationalReportPage';
export default function DeadStockReportPage() { return <OperationalReportPage kind="dead-stock"/>; }
